import { render, staticRenderFns } from "./AccountUserProfile.vue?vue&type=template&id=226a0b3b&"
import script from "./AccountUserProfile.vue?vue&type=script&lang=js&"
export * from "./AccountUserProfile.vue?vue&type=script&lang=js&"
import style0 from "./AccountUserProfile.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports